import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'antd'

import PhoneInput from 'components/PhoneInput'
import FacilityTypeDropdown from 'components/FacilityTypeDropdown'
import usNumberValidator from 'utils/helpers/usNumberValidator'
import AddressAutocomplete from 'components/AddressAutocomplete'
import ConfidenceInput from 'components/ConfidenceInput/ConfidenceInput'

import { Input } from 'ui/styled'
import { FormItem } from './styled'

const validateMessages = {
  required: 'Required'
}

const rules = [{ required: true, whitespace: true }]

const FacilityCreateForm = ({ form }) => (
  <Form
    form={form}
    labelCol={{ span: 24 }}
    validateMessages={validateMessages}
    initialValues={{ confidence: 5 }}
  >
    <FormItem label="Name" name="name" rules={rules}>
      <Input placeholder="Facility Name" data-test="createFacilityName" />
    </FormItem>

    <FormItem label="Confidence" name="confidence" rules={[{ required: true }]}>
      <ConfidenceInput />
    </FormItem>

    <FormItem name="location_types" rules={[{ required: true }]}>
      <FacilityTypeDropdown
        onSave={selectedItems => {
          form.setFieldValue('location_types', selectedItems)
        }}
        style={{ width: '100%' }}
        dataTest="createFacilityType"
      />
    </FormItem>

    <FormItem
      label="Phone"
      name={['phone_numbers', 0, 'phone']}
      rules={[
        {
          validator: usNumberValidator,
          required: true
        }
      ]}
    >
      <PhoneInput />
    </FormItem>

    <FormItem label="Address" name="address" rules={rules}>
      <AddressAutocomplete
        placeholder="Enter Address"
        data-test="createFacilityAddressInput"
      />
    </FormItem>
  </Form>
)

FacilityCreateForm.propTypes = {
  form: PropTypes.object.isRequired
}

export default FacilityCreateForm
